/**
 * tutorialesConfig.js — Contenido de cada tutorial de la app.
 * Cada tutorial tiene un id único y un array de pasos.
 */

export const TUTORIALES = {

  equipo_tactico: [
    {
      emoji: '',
      titulo: 'Sorteo de Draft',
      texto: 'Antes de armar tu equipo girás 4 ruletas: Presupuesto, Formación, Cantidad de restricciones y las restricciones en sí. En tu dispositivo verás un botón que te asignará tus restricciones',
    },
    {
      emoji: '',
      titulo: 'Armá tu equipo',
      texto: 'Tocá cualquier posición en la cancha para abrir el mercado de jugadores. Tenés que completar los 11 titulares y elegir un capitán + 4 suplentes dentro del presupuesto sorteado.',
    },
    {
      emoji: '',
      titulo: 'Restricciones',
      texto: 'En el panel de la derecha ves tus restricciones en tiempo real. Cada una te da un desafío extra, cada restricción se vincula a un nuevo filtro para elegir jugadores. Para cumplirlas, el jugador tiene que estar como titular o en duda(Verde o naranja), si está en rojo porque no juega esa fecha, no cuenta para cumplir la restricción. Los suplentes tampoco cumplen restricciones.',
    },
    {
      emoji: '',
      titulo: 'Confirmá el equipo',
      texto: 'Una vez elegidos los 11 titulares, confirma el equipo antes del cierre de jornada. Mientras no esté confirmado, los rivales podrán usar comodines para sabotear tu presupuesto. Recuerda: sin confirmación no sumas puntos',
    },
  ],

  equipo_libre: [
    {
      emoji: '',
      titulo: 'Modo Libre',
      texto: 'Acá armás tu equipo a tu gusto sin restricciones. Tenés $75M de presupuesto y podés elegir cualquier formación y jugador que quieras.',
    },
    {
      emoji: '',
      titulo: 'Cambios ilimitados',
      texto: 'En modo libre podés cambiar jugadores cuando quieras mientras la ventana de transferencias esté abierta. Sin límite de movimientos.',
    },
  ],

  por_los_puntos: [
    {
      emoji: '',
      titulo: 'Por los puntos',
      texto: 'Acá desafiás a otros jugadores, el equipo para desafiar siempre es el táctico. Cada jornada recibís 3 desafíos automáticos contra rivales de tu división, y podés hacer 2 más de forma manual.',
    },
    {
      emoji: '',
      titulo: 'Sistema de divisiones',
      texto: 'Empezás en división D. Cada victoria suma 3 puntos, empate 1, derrota 0. Llegás a la meta de puntos en tu ciclo de partidos y ascendés de división.',
    },
    {
      emoji: '',
      titulo: 'Ascenso y descenso',
      texto: 'En las divisiones altas (B,A, DTXI) si no llegás al mínimo de puntos al completar el ciclo, descendés. ¡Mantené el nivel!',
    },
  ],

  torneos: [
    {
      emoji: '',
      titulo: 'Torneos',
      texto: 'Podés unirte a torneos de tu club o crear los tuyos. Los torneos tacticos tienen su propio tablero tipo juego de mesa donde podes obtener comodines. Para crear o unirte debes confirmar tu equipo antes del cierre de la jornada.',
    },
    {
      emoji: '',
      titulo: 'El tablero',
      texto: 'Al inicio de cada jornada tirás el dado y avanzás casilleros. Podés caer en bonus de presupuesto, comodines o penalizaciones. ¡La suerte también cuenta!',
    },
  ],

  torneo_tactico: [
    {
      emoji: '',
      titulo: 'Torneo Táctico',
      texto: 'En este torneo cada jornada girás las ruletas para obtener tu formación, presupuesto y restricciones. Todos juegan con desafíos distintos.',
    },
    {
      emoji: '',
      titulo: 'Restricciones',
      texto: 'Cumplir tus restricciones es parte del objetivo para poder confirmar tu equipo.',
    },
    {
      emoji: '',
      titulo: 'El tablero',
      texto: 'Con cada jornada avanzás en el tablero. Caer en casilleros especiales te da comodines que podés usar para la siguiente fecha para cambiar restricciones, sumarte presupuesto o sabotear a rivales.',
    },
  ],

  torneo_libre: [
    {
      emoji: '',
      titulo: 'Torneo Libre',
      texto: 'Sin restricciones ni ruletas — armás tu equipo a puro criterio con $60M de presupuesto.',
    },
    {
      emoji: '',
      titulo: 'Transferencias libres',
      texto: 'Podés cambiar jugadores cada jornada sin límite mientras la ventana esté abierta. La estrategia y el conocimiento del mercado son tu ventaja.',
    },
    {
      emoji: '',
      titulo: 'Cómo ganar',
      texto: 'El puntaje se basa en las calificaciones internas de DTXI. Consultá el reglamento completo en tu perfil. ¡Recordá que el capitán duplica sus puntos!',
    },
  ],

  prode: [
    {
      emoji: '',
      titulo: 'Prode',
      texto: 'Predecí los resultados de los partidos antes de que empiecen. Tenés tiempo hasta el inicio del primer partido para cargar tus pronósticos.',
    },
    {
      emoji: '',
      titulo: 'Puntaje',
      texto: 'Acertar el resultado exacto (ej: 2-1) da más puntos que solo acertar el ganador. Los empates exactos también suman. Resultado exacto +5, ganador correcto +2, diferencia de goles correcta +3.',
    },
  ],

  torneo_prode: [
    {
      emoji: '',
      titulo: 'Prode',
      texto: 'Predecí los resultados de los partidos antes de que empiecen. Cuanto más exacto sea tu pronóstico, más puntos sumás.',
    },
    {
      emoji: '',
      titulo: 'Puntaje',
      texto: 'Acertar el resultado exacto (ej: 2-1) da más puntos que acertar solo el ganador. Los empates correctos también suman. Resultado exacto +5, ganador correcto +2, diferencia de goles correcta +3.',
    },
  ],

  clan: [
    {
      emoji: '',
      titulo: 'Tu club',
      texto: 'El club es tu grupo de amigos. Juntos participan en torneos, guerras y retos contra otros clubes para sumar puntos, medallas y escalar en el ranking.',
    },
    {
      emoji: '',
      titulo: 'Guerras de clubes',
      texto: 'Con "Retar a un club" elegís 5 miembros y entrás a la cola de matchmaking — el sistema te empareja automáticamente con otro club. No elegís el rival, el sistema lo asigna.',
    },
    {
      emoji: '',
      titulo: 'Retos grupales',
      texto: 'Los retos son desafíos en formato 2v2, 3v3 o 5v5, etc. Cualquier miembro puede proponer uno — el líder o colider lo aprueba. El sistema empareja al grupo contra rivales de otro clan.',
    },
    {
      emoji: '',
      titulo: 'Puntos de club',
      texto: 'Cada guerra o reto ganado suma puntos al club. Con más puntos subís en el ranking.',
    },
  ],

  ranking: [
    {
      emoji: '',
      titulo: 'Ranking',
      texto: 'Acá ves cómo estás parado contra el resto. Hay ranking general por puntos totales, ranking de clubes y tabla de la jornada actual.',
    },
  ],

  palmares: [
    {
      emoji: '',
      titulo: 'Tu Palmarés',
      texto: 'Acá se guarda todo tu historial — fechas ganadas, divisiones alcanzadas, medallas desbloqueadas y estadísticas de todos los modos de juego.',
    },
    {
      emoji: '',
      titulo: 'Jugadas Preparadas',
      texto: 'Hay 7 medallas ocultas especiales que solo se revelan cuando las lográs. No hay pistas — descubrilas jugando.',
    },
  ],

  formidable: [
    {
      emoji: '',
      titulo: '¿Qué es Formidable?',
      texto: 'Hay un jugador misterioso. Fue figura en el fútbol argentino durante su "año formidable". Tenés 15 preguntas para descubrir quién es.',
    },
    {
      emoji: '',
      titulo: 'Cómo preguntar',
      texto: 'Usá las pestañas para elegir el tipo de pregunta. Cada una gasta un intento, así que pensá bien antes de preguntar.',
    },
    {
      emoji: '',
      titulo: 'Jugó en...',
      texto: 'Escribí el nombre de un club y el juego te dice si el jugador estuvo ahí en algún momento de su carrera. Solo sí o no.',
    },
    {
      emoji: '',
      titulo: 'País y Región / año',
      texto: '"País" te dice si es de esa nacionalidad. "Región / año" te dice si jugó en ese país o continente en un año específico. Combinadas acotan muy rápido.',
    },
    {
      emoji: '',
      titulo: 'Año formidable',
      texto: 'Ingresá un año y el juego te dice si su año formidable fue antes, después o exactamente ese. Ideal para acotar en pocas preguntas.',
    },
    {
      emoji: '',
      titulo: 'Cuidado con Adivinar',
      texto: 'La pestaña "Adivinar" es tu única oportunidad de ganar — pero si el nombre que elegís es incorrecto, perdés la partida al instante. Solo cuando estés seguro.',
    },
    {
      emoji: '',
      titulo: 'Un jugador por día',
      texto: 'El jugador misterioso se renueva a medianoche. Si ya jugaste hoy, volvé mañana para el siguiente desafío.',
    },
  ],

  // ── NUEVO: Formaciones Míticas ──────────────────────────────────────────────
  formaciones_miticas: [
    {
      emoji: '',
      titulo: '¡Bienvenido a Formaciones Míticas!',
      texto: 'Vas a ver una cancha con 11 camisetas sin nombre. Tu misión: completar el once titular de un equipo histórico escribiendo los apellidos de los jugadores.',
    },
    {
      emoji: '⏱',
      titulo: 'Tenés 2 minutos y 30 segundos',
      texto: 'El reloj corre desde que empieza el juego. Si se acaba el tiempo, la partida termina y se muestran los jugadores que te faltaban.',
    },
    {
      emoji: '',
      titulo: '¿Cómo jugar?',
      texto: 'Escribí un apellido en el casillero de abajo y presioná Enter o el botón Enviar. No importan mayúsculas ni tildes. Si es correcto, aparece en la camiseta.',
    },
    {
      emoji: '',
      titulo: 'Guiones = letras',
      texto: 'Debajo de cada camiseta hay guiones que te indican cuántas letras tiene el apellido. Usálos como pista para acotar tus intentos.',
    },
  ],

};